import AdminInput from "../../components/AdminInput";
import { useTranslation } from "react-i18next";

const AccountInformation = ({
    loading,
    data
}) => {
    const { t } = useTranslation();
    return (
        <div className="card-body px-4">
            <div className="row d-flex align-items-start justify-content-between py-2">
                <div className="col-12 col-lg-10">
                    <p className="fw-400 mb-2">
                        Email Address
                    </p>
                    <p className="fw-700 mb-0">
                        {data?.email}
                    </p>
                </div>
                {
                    false && (
                        <div className="col-12 col-lg-2 d-flex align-items-center justify-content-end">
                            <button
                                type="button"
                                className="btn btn-change-email mt-4 mt-lg-0"
                                onClick={() => { }}
                                disabled={data?.changeEmailVerificationStatus === false}
                            >
                                {t("myPage.accountInformation.subMenu.email.button")}
                            </button>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default AccountInformation;
